import { secondsToHoursAndMinutesString } from '@/helpers/dateHelper';
import { FC } from 'react';
import { useRosterDayStats } from '../providers/WorkingRosterService';
import strings from '../roster.translations';
import { RosterDrawerStatCard } from './RosterDrawerStatCard';

export const RosterSummary: FC = () => {
  const rosterSummary = useRosterDayStats();

  const stats = [
    {
      label: strings.drawer.summary.timeWorked,
      value: secondsToHoursAndMinutesString(rosterSummary.actualTotal)
    },
    {
      label: strings.drawer.summary.totalStaffRostered,
      value: rosterSummary.totalStaffRostered
    },
    {
      label: strings.drawer.summary.totalShifts,
      value: rosterSummary.totalShifts
    }
  ];

  return (
    <div className="flex gap-3 mt-3">
      {stats.map(s => (
        <RosterDrawerStatCard key={s.label} label={s.label} value={s.value} />
      ))}
    </div>
  );
};
